<template>
  <div id="L2" class="sub excr">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <h1 class="tit1">パスワードの再設定</h1>
            <p class="lead_upper type2">
              変更内容をご確認のうえ、変更してください。
            </p>
            <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
            <div v-if="validateErrorMessages">
              <div v-for="(msg,index) in validateErrorMessages" :key="index"><label class="error_text">{{msg}}</label></div>
            </div>
            <ul class="lst_find">
              <li>
                <div class="item">メールアドレス：</div>
                <div class="cnt">
                  <input type="text" id="id" name="id" readonly v-model="userForm.userEmail">
                </div>
              </li>
              <li>
                <div class="item">新しいパスワード：</div>
                <div class="cnt">
                  <input type="password" id="pw" name="pw" readonly v-model="userForm.password"><a class="pw_display" @click="pwDisplayClick()">表示する</a>
                </div>
              </li>
            </ul>
            <div class="fixed_btn_area">
              <ul class="inner_static">
                <li>
                  <a class="btn2" @click="back()">戻る</a>
                </li>
                <li>
                  <a class="btn1" @click="update()">変更する</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'

// kagull Module
import Header from '../components/common/HomeIconHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      userForm: {
        password: '',
        confirmPassword: '',
        userEmail: '',
        token: ''
      },
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    update: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      let payload = {
        userEmail: this.userForm.userEmail,
        token: this.userForm.token,
        password: this.userForm.password,
        confirmPassword: this.userForm.confirmPassword
      }
      axios.post(KG_URL.USER + '/reset/password', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // 完了画面に遷移
            this.$router.push('/kagull/user/reset/complete')
            this.$refs.loadingModalRef.showModal(false)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$refs.loadingModalRef.showModal(false)
        })
        .finally(() => {
          this.submitDisable = false
        })
    },
    back: function () {
      this.$router.push('/kagull/user/reset/update')
    },
    pwDisplayClick: function () {
      // パスワード表示
      let e = document.getElementById('pw')
      e.setAttribute('type', 'text')
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    }
  },
  created () {
    // 入力画面でセットされた値を設定する
    let input = App.getLocalStorage(KG_STORAGE_KEY.PASSWORD_DATA)
    this.userForm.userEmail = input.userEmail
    this.userForm.password = input.password
    this.userForm.confirmPassword = input.confirmPassword
    this.userForm.token = input.token
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/PasswordResetUpdateConfirm.vue